import React from 'react';
import { JsonLd } from 'components/JsonLd';
import { HeadSection } from 'components/HeadSection';
import { useProductDetailState } from 'contexts';
import { useTenantConfig } from 'hooks';
import { Product, WithContext } from 'schema-dts';

export const MetaData: React.FC = () => {
  const { product, primitiveProduct } = useProductDetailState();
  const { baseDomain, canonicalDomain } = useTenantConfig();

  let canonical: string | undefined;
  if (primitiveProduct?.productInfo?.canonical) {
    if (canonicalDomain) {
      canonical = `${canonicalDomain}/${primitiveProduct.productInfo.canonical}`;
    } else if (baseDomain) {
      canonical = `${baseDomain}/${primitiveProduct.productInfo.canonical}`;
    }
  }

  const data: WithContext<Product> = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: primitiveProduct?.productInfo?.name,
    image: primitiveProduct?.productInfo?.imageUrl,
    brand: {
      '@type': 'Brand',
      name: primitiveProduct?.productInfo?.brand?.name,
    },
    offers: {
      '@type': 'Offer',
      price: primitiveProduct?.prices?.[0]?.latestPrice || 0,
      url: `${baseDomain}/${primitiveProduct?.productInfo?.canonical}`,
      priceCurrency: 'VND',
      itemCondition: 'https://schema.org/NewCondition',
      availability:
        primitiveProduct?.totalAvailable === null ||
        !!primitiveProduct?.totalAvailable
          ? 'https://schema.org/InStock'
          : 'https://schema.org/OutOfStock',
    },
    url: `${baseDomain}/${primitiveProduct?.productInfo?.canonical}`,
    description: primitiveProduct?.productDetail?.seoInfo?.metaDescription,
    sku: primitiveProduct?.productInfo?.sku,
    category: primitiveProduct?.productInfo.categories?.[0]?.name,
    additionalProperty: product?.attributeGroups
      ?.filter((att) => !!att.value && att.parentId !== 0)
      .map((att) => ({
        '@type': 'PropertyValue',
        name: att.name,
        value: att.value,
      })),
  };

  return (
    <>
      {/*Đánh dấu JSON-LD*/}
      <JsonLd data={data} />
      <HeadSection
        canonical={canonical}
        title={product?.seoInfo?.metaTitle || product?.name}
        description={product?.seoInfo?.metaDescription || false}
        keywords={product?.seoInfo?.metaKeyword}
        image={product?.images?.[0]?.src}
      />
    </>
  );
};
